import axios from "axios";

const API_BASE = "https://dashboard.lono.co.in/api/communication";

// Helper to build headers with Authorization
const buildHeaders = (token) =>
  token
    ? { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    : { headers: { "Content-Type": "application/json" } };

// ===== TEMPLATES =====
export const getTemplates = async () => {
  const res = await axios.get(`${API_BASE}/templates`);
  return res.data.data;
};

export const getTemplateById = async (id) => {
  const res = await axios.get(`${API_BASE}/templates/${id}`);
  return res.data.data;
};

export const createTemplate = async (template) => {
  const res = await axios.post(`${API_BASE}/templates`, template, buildHeaders());
  return res.data.data;
};

export const updateTemplate = async (id, template) => {
  const res = await axios.put(`${API_BASE}/templates/${id}`, template, buildHeaders());
  return res.data.data;
};

export const deleteTemplate = async (id) => {
  const res = await axios.delete(`${API_BASE}/templates/${id}`, buildHeaders());
  return res.data;
};

// ===== SEND TEMPLATE =====
export const sendTemplate = async (id, token) => {
  if (!token) throw new Error("Authorization token is required");
  const res = await axios.post(`${API_BASE}/templates/${id}/send`, {}, buildHeaders(token));
  return res.data;
};

// ===== MESSAGE LOGS =====
export const getMessageLogs = async (page = 1, limit = 10) => {
  const params = { page, limit };
  const res = await axios.get(`${API_BASE}/message-logs`, { params });
  return res.data;
};

export const getMessageStats = async () => {
  const res = await axios.get(`${API_BASE}/message-stats`);
  return res.data;
};

// ===== RECIPIENTS =====
export const getRecipients = async (params = {}) => {
  const token = localStorage.getItem('token');
  console.log('API call to:', `${API_BASE}/recipients`);
  console.log('With params:', params);
  console.log('With token:', token ? 'Present' : 'Missing');
  
  const res = await axios.get(`${API_BASE}/recipients`, { 
    params,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  return res.data;
};

// ===== LOAN TYPES =====
export const getLoanTypes = async () => {
  const res = await axios.get(`${API_BASE}/loan-types`);
  return res.data;
};

// ===== BULK NOTIFICATIONS =====
export const sendBulkNotification = async (payload, token) => {
  if (!token) throw new Error("Authorization token is required");
  const res = await axios.post(`${API_BASE}/bulk-notification`, payload, buildHeaders(token));
  return res.data;
};
